export default __webpack_public_path__ + "static/service-1-c3cda494f179afb78141ae48a6421c15.jpg";